import { render, staticRenderFns } from "./ClientDtiInfoPopUp.vue?vue&type=template&id=47ebd4d5&scoped=true&"
import script from "./ClientDtiInfoPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientDtiInfoPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientDtiInfoPopUp.vue?vue&type=style&index=0&id=47ebd4d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ebd4d5",
  null
  
)

export default component.exports